import React from 'react';
import { useDeliveryMode } from '@/contexts/DeliveryModeContext';

const DeliveryModeToggle = ({ className = "" }) => {
  const { isDeliveryMode, toggleDeliveryMode, isLoading, isRider } = useDeliveryMode();


  // Only show toggle for delivery/rider roles
  if (!isRider || isLoading) {
    return null;
  }

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <span className="text-sm font-medium text-gray-700">
        Delivery Mode
      </span>
      <label className="relative inline-flex items-center cursor-pointer">
        <input
          type="checkbox"
          className="sr-only peer"
          checked={isDeliveryMode}
          onChange={toggleDeliveryMode}
        />
        <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
      </label>
    </div>
  );
};

export default DeliveryModeToggle;
